(() => {
  let pending;
  let blocked = false;
  const root = window.Shopify.routes.root;
  async function request(path, body) {
    const response = await fetch(root + path, body ? {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)} : {cache: 'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error('Gift unavailable');
    return data;
  }
  function warn() {
    document.querySelectorAll('mas-gift-progress').forEach(el => {
      el.querySelector('[role="status"]').textContent = el.dataset.conflict;
    });
  }
  async function refreshCart() {
    const drawer = document.querySelector('cart-drawer');
    const cartPath = root + 'cart';
    if (!drawer || window.location.pathname.replace(/\/$/, '') === cartPath.replace(/\/$/, '')) {
      window.location.reload();
      return;
    }
    const wasOpen = drawer.classList.contains('active');
    const sections = await request('?sections=cart-drawer,cart-icon-bubble');
    if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error('Cart refresh unavailable');
    drawer.renderContents({sections}, wasOpen);
    if (blocked) warn();
  }
  async function sync(element) {
    if (pending) return pending;
    pending = (async () => {
      const variant = Number(element.dataset.variant);
      let cart = await request('cart.js');
      if (cart.currency !== 'CHF') return;
      const previousGifts = cart.items.filter(item => item.properties?._mas_free_gift === 'missha-100');
      const migrated = previousGifts.length > 0;
      if (migrated) {
        await request('cart/update.js', {updates: Object.fromEntries(previousGifts.map(item => [item.key, 0]))});
        cart = await request('cart.js');
      }
      const total = cart.items.filter(item => item.variant_id !== variant).reduce((sum, item) => sum + item.original_line_price, 0);
      const managed = cart.items.filter(item => item.variant_id === variant && item.properties?._mas_free_gift === 'anua-vitamin-c-80');
      const freeGift = cart.items.some(item => item.variant_id === variant && item.final_line_price === 0);
      if (total < 8000 || managed.some(item => item.final_line_price > 0)) {
        if (total < 8000) { blocked = false; sessionStorage.removeItem('mas-gift-conflict-anua-80'); }
        if (managed.length) {
          const updates = Object.fromEntries(managed.map(item => [item.key, 0]));
          await request('cart/update.js', {updates});
          if (total >= 8000) { blocked = true; sessionStorage.setItem('mas-gift-conflict-anua-80', '1'); }
          await refreshCart();
        }
        if (migrated && !managed.length) await refreshCart();
        return;
      }
      if (freeGift) { sessionStorage.removeItem('mas-gift-conflict-anua-80'); if (migrated) await refreshCart(); return; }
      if (blocked || sessionStorage.getItem('mas-gift-conflict-anua-80')) { warn(); return; }
      try {
        await request('cart/add.js', {items: [{id: variant, quantity: 1, properties: {_mas_free_gift: 'anua-vitamin-c-80'}}]});
        const updated = await request('cart.js');
        const gift = updated.items.find(item => item.variant_id === variant && item.properties?._mas_free_gift === 'anua-vitamin-c-80');
        if (!gift || gift.final_line_price !== 0) {
          if (gift) await request('cart/change.js', {id: gift.key, quantity: 0});
          blocked = true;
          sessionStorage.setItem('mas-gift-conflict-anua-80', '1');
        }
        await refreshCart();
      } catch {
        blocked = true;
        warn();
      }
    })().catch(warn).finally(() => { pending = null; });
    return pending;
  }
  customElements.define('mas-gift-progress', class extends HTMLElement {
    connectedCallback() { sync(this); }
  });
  document.addEventListener('click', async event => {
    const checkout = event.target.closest('[name="checkout"], a[href="/checkout"]');
    const element = document.querySelector('mas-gift-progress');
    if (!checkout || !element || checkout.dataset.giftReady) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    await sync(element);
    checkout.dataset.giftReady = 'true';
    checkout.click();
    delete checkout.dataset.giftReady;
  }, true);
})();


